import React from "react";
import Gologo from "../Images/glogo.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, // animations happen only once
    });
  }, []);

  return (
    <div className="bg-gray-50 text-gray-800" id="about">
      {/* Hero Section */}
      <div
        className="relative bg-gradient-to-r from-green-100 to-blue-100"
        data-aos="fade-down"
      >
        <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8 text-center">
          <img src={Gologo} alt="GeeCom Logo" className="mx-auto h-16 mb-4" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            About GeeCom India
          </h1>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Empowering communities and businesses through digital
            transformation.
          </p>
        </div>
      </div>

      {/* Company Overview */}
      <section className="py-24 px-6 max-w-7xl mx-auto space-y-20">
        {/* WHO WE ARE */}
        {/* WHO WE ARE */}{" "}
        <div
          className="flex justify-center items-center mb-6"
          data-aos="zoom-in"
        >
          <h2 className="text-4xl font-bold text-gray-900 text-center">
            Who We Are
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}

          <div data-aos="fade-right">
            <img
              src="https://www.geecomindia.com/img/about-us.jpeg"
              alt="Wheat field with sun"
              className="w-full h-auto md:h-[570px] object-cover shadow-md rounded"
            />
          </div>

          {/* Right: Content */}
          <div data-aos="fade-left">
            <p className="text-lg text-gray-500 leading-relaxed mb-4">
              GeeCom India Services Private Limited has been founded in year
              2018 at Indore, Madhya Pradesh, India. 'GeeCom India' is an
              E-commerce platform currently focused on 'Farming' and 'Rural
              India'.
            </p>
            <p className="text-lg text-gray-500 leading-relaxed mb-4">
              'GeeCom India' is a transparent and democratic platform which
              connects Farmers and Rural Sellers/Producers/Crafters to
              Consumers, City, Businesses and Industries.
            </p>
            <p className="text-lg text-gray-500 leading-relaxed mb-4">
              Traditional approach adds layers, middleman, unwanted processes,
              etc., this result into lesser benefits for sellers and higher cost
              for buyers. Our platform enables rural producers and buyers to
              connect & transact directly with each other and it’s truly a
              Win-Win platform. Direct connection enables rural producers &
              farmers to get better prices and 'Sell directly from Home or
              Farm'.
            </p>
            <p className="text-lg text-gray-500 leading-relaxed">
              We at 'GeeCom India' believe that 'Farmers' & 'People in Rural
              India' should also reap the benefits of Digital India. We think
              improved income of 'Farmers' & 'People in Rural India' will help
              both Indian Economy and as well as status & quality of life for
              millions of people. We hope this will also lead to more 'Organic',
              'Natural' and 'Responsible Farming' therefore 'Better Consumer
              Health'.
            </p>
          </div>
        </div>
        {/* MISSION & VISION */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Mission */}
          <div
            className="bg-gradient-to-tr from-blue-50 to-white p-8 rounded-3xl shadow-md"
            data-aos="flip-left"
          >
            <h3 className="text-2xl font-bold text-blue-800 mb-6 flex items-center">
              <span className="mr-2">🎯</span> GeeCom India's Mission is:
            </h3>
            <ul className="space-y-5 text-gray-700 text-base leading-relaxed list-disc list-inside">
              <li>
                To provide a Win-Win platform that will benefit all our users.
              </li>
              <li>
                To create value for every user in very transparent and
                democratic manner.
              </li>
              <li>
                To support and facilitate E-commerce for ‘Farmers’ and ‘Rural
                India’.
              </li>
              <li>
                To encourage and promote 'Organic', 'Natural' and ‘Responsible
                Farming’ therefore 'Better Consumer Health'.
              </li>
              <li>
                To Support and Strengthen the Core (Farms and Villages) of
                Indian Economy.
              </li>
            </ul>
          </div>

          {/* Vision */}
          <div
            className="bg-gradient-to-tr from-green-50 to-white p-8 rounded-3xl shadow-md"
            data-aos="flip-right"
          >
            <h3 className="text-2xl font-bold text-green-800 mb-6 flex items-center">
              <span className="mr-2">🌱</span> GeeCom India's Vision is:
            </h3>
            <ul className="space-y-5 text-gray-700 text-base leading-relaxed list-disc list-inside">
              <li>
                That every Indian should be part of digital journey and shall
                reap the benefits of 'Digital India'.
              </li>
              <li>
                That benefits of E-commerce & Digital Technologies reaches to
                'Farmers' & 'People in Rural India'.
              </li>
              <li>
                That income of 'Farmers' & 'People in Rural India' improves
                therefore their status and quality of life.
              </li>
              <li>
                Widespread adoption of 'Organic' and 'Natural' farming so that
                ‘Quality of Food’ and ‘Health of Consumers’ improves.
              </li>
              <li>
                Establish 'GeeCom India' as a constructive and positive brand
                that contributes in society and spreads smiles among everyone.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Services Highlight */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-12">What We Offer</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
            {[
              {
                title: "QR-Based Digital Identity",
                desc: "Secure and smart identity solutions for individuals and enterprises.",
              },
              {
                title: "Retail Shop Management",
                desc: "Tools to manage inventory, sales, and customer engagement efficiently.",
              },
              {
                title: "Agriculture Solutions",
                desc: "Empowering farmers with digital records, tracking, and analytics.",
              },
              {
                title: "Survey & Documentation",
                desc: "Accurate digital records and compliance-ready documentation services.",
              },
              {
                title: "Handicraft Promotion",
                desc: "Supporting rural artisans with online presence and market reach.",
              },
              {
                title: "Custom Solutions",
                desc: "Tailored tech tools designed for your specific organizational needs.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="border border-gray-200 p-6 rounded-xl shadow-sm hover:shadow-md transition"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <h3 className="text-xl font-semibold mb-2 text-blue-700">
                  {item.title}
                </h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section
        className="bg-blue-600 py-12 text-white text-center"
        data-aos="zoom-in-up"
      >
        <h2 className="text-2xl font-semibold mb-2">Ready to work with us?</h2>
        <p className="mb-6">Let’s build something impactful together.</p>
        <a
          href="#contact"
          className="bg-white text-blue-600 px-6 py-3 rounded-full font-medium hover:bg-gray-100 transition"
        >
          Contact Us
        </a>
      </section>
    </div>
  );
};

export default AboutUs;
